import axios from "axios";
import { baseAPIURL } from "../config/authConfig";

const axiosInstance = () => {
  return axios.create({
    baseURL: baseAPIURL,
    headers: {
      "Content-Type": "application/json"
    }
  });
};

export default axiosInstance();
